import DtoMaterielAssignment from './DtoMaterielAssignment'
import DtoCentral from './DtoCentral'

export default class DtoStationCentralAssignment extends DtoMaterielAssignment {
    constructor(obj) {
        super(obj)
        this.id = obj.idCentralSituation
        this.idCentralSituation = obj.idCentralSituation
        this.idCentral = obj.idCentral
        this.materielId = obj.idCentral
        this.materiel = obj.materiel && new DtoCentral(obj.materiel)
    }
}